import React, {useEffect, useState} from 'react';
import {Menu, Dropdown, Avatar, Typography, Modal, List, Button, Input, Divider} from 'antd';
import {useDispatch, useSelector} from 'react-redux'
import {
    LogoutOutlined,
    InfoCircleOutlined,
    DoubleRightOutlined,
    FileDoneOutlined,
    CodeSandboxOutlined,
    DesktopOutlined,
    UserOutlined,
    RetweetOutlined,
    AlignRightOutlined, SettingOutlined,
    MoreOutlined
} from '@ant-design/icons';
import {signOut} from 'store/slices/authSlice';
import {Link} from "react-router-dom";
import {APP_PREFIX_PATH} from "../../configs/AppConfig";
import ApiService from "../../services/ApiService"
import {authenticated} from "store/slices/authSlice";
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import {isMobile} from "react-device-detect";

const {Text} = Typography

const MenuItemSignOut = ({label, type = "", Icon}) => (
    <Text type={type}>
        <Icon className="font-size-md"/>
        <span className="font-weight-normal mx-2">{label}</span>
    </Text>
)

export const NavProfile = () => {

    const org = useSelector(state => state.auth.org)
    const access = useSelector(state => state.auth.access)

    const [isModalOrgOpen, setIsModalOrgOpen] = useState(false);


    const dispatch = useDispatch();

    const handleClick = ({key}) => {
        if (key === 'Sign Out') {
            handleSignOut()
        }
    }

    const handleSignOut = () => {
        dispatch(signOut())
    }

    var menuItems = [
        {
            key: 'preference',
            label: <Link to={APP_PREFIX_PATH + "/preferences/tabs"}><MenuItemSignOut label="Préferences" type=""
                                                                                     Icon={SettingOutlined}/></Link>,
        },
        {
            key: 'Sign Out',
            label: <MenuItemSignOut label="Déconnexion" type="danger" Icon={LogoutOutlined}/>,
        }
    ]

    if (access.id === "DEMO_ACCESS_APPLE" && isMobile) {
        menuItems.splice(0, 1)
    }

    if (access.type === "ADMIN") {
        menuItems = [
            {
                key: '0',
                label: <Link to={APP_PREFIX_PATH + "/info/tabs"}><MenuItemSignOut label="Mon Organisation" type=""
                                                                                  Icon={InfoCircleOutlined}/></Link>,
            },
            {

                key: '1',
                label: <Link to={APP_PREFIX_PATH + "/access/list"}><MenuItemSignOut label="Utilisateurs" type=""
                                                                                    Icon={UserOutlined}/></Link>,
            },
            {
                key: '10',
                label: <Link to={APP_PREFIX_PATH + "/bornes/tabs"}><MenuItemSignOut label="Tsedasmart" type=""
                                                                                    Icon={CodeSandboxOutlined}/></Link>,
            },
            {
                key: '2',
                label: <Link to={APP_PREFIX_PATH + "/virements/list"}><MenuItemSignOut label="Virements" type=""
                                                                                       Icon={DoubleRightOutlined}/></Link>,
            },
            {
                key: '3',
                label: <Link to={APP_PREFIX_PATH + "/factures/list"}><MenuItemSignOut label="Factures" type=""
                                                                                      Icon={FileDoneOutlined}/></Link>,
            },

            ...menuItems
        ]
    }

    const menu = (
        <Menu
            onClick={handleClick}
            items={menuItems}
        />
    )

    return (
        <div className="nav-item" style={{paddingRight:0}}>
            <div className="d-flex align-items-center">
                {org?.logo && (
                    <>
                        <Avatar src={org.logo} size={"large"} onClick={() => setIsModalOrgOpen(true)}/>
                        <ModalOrgs visible={isModalOrgOpen} onClose={() => setIsModalOrgOpen(false)}/>
                    </>
                )}

                <Dropdown overlay={menu} trigger={["click"]}>
                    <div style={{display:"flex",alignItems:"center",marginLeft:10,gap:10}}>
                        <div className="d-sm-block profile-text">
                            {org?.name && <div className="font-size-base font-weight-bold" style={{whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",maxWidth:"35vw"}}>{isMobile?org.shortName:org.name}</div>}
                            <span className="opacity-0-8" style={{whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",maxWidth:"35vw"}}>{access.nom} {access.prenom}</span>
                        </div>

                        <div className="d-block profile-text">
                            <MoreOutlined className="nav-icon mr-0"/>
                        </div>
                    </div>
                </Dropdown>

            </div>
        </div>
    );
}


export function ModalOrgs({visible, onClose}) {
    const dispatch = useDispatch()
    const org = useSelector(state => state.auth.org)
    const [accessOrgs, setAccessOrgs] = useState([])
    const [search, setSearch] = useState("")

    async function getAccessOrgs() {
        const res = await ApiService.get("/access/organisations")
        if (res.success) {
            setAccessOrgs(res.data)
        }
    }

    async function changeOrg(orgId) {
        onClose()

        const res = await ApiService.post("/access/change/" + orgId)
        console.log(res)
        dispatch(authenticated(res))
        localStorage.setItem("AUTH_TOKEN", res.token);
        //localStorage.setItem("ORG", res.token);
        window.location.reload()
    }

    useEffect(() => {
        getAccessOrgs()
    }, [])


    var finalList = accessOrgs.filter(i => i.id !== org.id).sort((a, b) => a.shortName.localeCompare(b.shortName, 'fr'))

    var searchList = finalList

    if (search !== "") {
        const formatedSearch = search.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()

        searchList = finalList.filter(i => {
            const formatedName = i.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
            const formatedShortName = i.shortName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()

            //console.log(formatedName,formatedShortName,formatedSearch)

            return formatedName.includes(formatedSearch) || formatedShortName.includes(formatedSearch)
        })
    }

    return (
        <Modal style={{maxHeight: "70vh"}} title="Changer d'organisation" centered
               open={visible && finalList.length > 0} footer={null} onCancel={onClose}>

            <Input.Search
                placeholder="Rechercher"
                onChange={e => setSearch(e.target?.value || "")}
                onSearch={value => setSearch(value)}
                allowClear
            />

            <Divider/>

            <List
                dataSource={searchList}
                renderItem={item => {
                    return (
                        <List.Item actions={[<Button size={"large"} type={"link"}
                                                     icon={<RetweetOutlined onClick={() => changeOrg(item.id)}/>}/>]}>
                            <List.Item.Meta
                                avatar={<Avatar src={item.logo}/>}
                                title={<Text>{item.shortName}</Text>}
                                description={<Text>{item.name}</Text>}
                            />
                        </List.Item>
                    )
                }}
            />
        </Modal>
    )

}

export default NavProfile
